/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ShippingInfoComponent.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H224423
 *
 * @Date         : Oct 21, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.Added Modification History.
 *
 * By            : E807238
 * On            : Nov 05, 2019
 * Description   : ASDS-1679: PO date, Upload PO document as optional fields
 *
 * By            : H422335
 * On            : Sep 07 2020
 * Description   : ASDS-2743 - Review Order UI Enhancements as part of APU Phase 2.
 *
 * By            : H422335
 * On            : Oct 08, 2020
 * Description   : ASDS-3512 UI Fixes.
 *
 * By             : H422336
 * On             : Oct 22,2020
 * Description    : ASDS-3580 APU Enhancements Phase-II
 *
 * By             : H422336
 * On             : Oct 22,2020
 * Description    : ASDS-3783 APU Enhancements Phase-II Bugfix
 *
 * By            : H422337
 * On            : Oct,29 2020
 * Description   : ASDS-3576- UI Enhancements of phase-2 - Migrating to Forge API
 *
 *******************************************************************************/

import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Table } from '@scuf/common';
import { ShippingInfoPropsI } from '../utils/checkout-interfaces';
import CheckoutConstants from '../constants/checkout-constants';

function DisplayContractPurchaseData(props) {
  let contractNums;

  if (props.contractPurchaseData) {
    let paymentType = '';

    contractNums = props.contractPurchaseData.map((contractDetails) => {
      if (contractDetails.contractType === CheckoutConstants.NON_MSA_PURCHASE_ORDER) {
        paymentType = 'Purchase Order';
      } else if (contractDetails.contractType === CheckoutConstants.NON_MSA_SERVICE_ORDER) {
        paymentType = 'Service Order';
      } else {
        paymentType = 'Contract';
      }

      return {
        contract: paymentType,
        number: contractDetails.contractNo
      };
    });

    contractNums = contractNums.filter((v, i, a) => a.findIndex(t => (t.number === v.number && t.contract === v.contract)) === i);
  }

  if (contractNums && contractNums.length > 0 && contractNums[0].number !== '') {
    return (
      <React.Fragment>
        <Table.Row>
          <Table.Cell className="payment-label">Payment Method</Table.Cell>
          <Table.Cell className="payment-label">Reference No.</Table.Cell>
        </Table.Row>
        {contractNums.map((payment, index) => {
          return (
            <Table.Row key={payment + index}>
              <Table.Cell>{payment.contract}</Table.Cell>
              <Table.Cell>{payment.number}</Table.Cell>
            </Table.Row>
          );
          })
        }
      </React.Fragment>
    );
  } else {
    return null;
  }
}

export function ShippingInfoComponent(props: ShippingInfoPropsI) {
  return (
    <React.Fragment>
      <Grid.Row>
        <Grid.Column width={12} className="paddingbottom">
          <span className="ro-heading-text">Payment Info</span>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={11} className="paddingbottom">
          <hr className="ro-hr-line" />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={12} className="review-payment-info">
          <Table className="plainTable unstackable">
            <Table.Body>
              {props.shippingBillingPaymentInfo.paymentMode === "PO" && (
                <React.Fragment>
                  <Table.Row>
                    <Table.Cell>Payment Method</Table.Cell>
                    <Table.Cell>Purchase Order</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>PO Number</Table.Cell>
                    <Table.Cell>
                      {props.shippingBillingPaymentInfo.poData.poNumber}
                    </Table.Cell>
                  </Table.Row>
                  {props.shippingBillingPaymentInfo.poData.poDate && (
                    <Table.Row>
                      <Table.Cell>PO Date</Table.Cell>
                      <Table.Cell>
                        {props.shippingBillingPaymentInfo.poData.poDate}
                      </Table.Cell>
                    </Table.Row>
                  )}
                  {props.shippingBillingPaymentInfo.poData.poFileName && (
                    <Table.Row>
                      <Table.Cell>PO Document</Table.Cell>
                      <Table.Cell>
                        {props.shippingBillingPaymentInfo.poData.poFileName}
                      </Table.Cell>
                    </Table.Row>
                  )}
                </React.Fragment>
              )}
              {props.shippingBillingPaymentInfo.paymentMode === 'CC' && (
                <React.Fragment>
                  <Table.Row>
                    <Table.Cell className="payment-method-info-label">Payment Method</Table.Cell>
                    <Table.Cell>Credit Card</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell className="payment-method-info-label">Name On Card</Table.Cell>
                    <Table.Cell>
                      {props.shippingBillingPaymentInfo.ccData.nameOnCard}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell className="payment-method-info-label">Credit Card Type</Table.Cell>
                    <Table.Cell>
                      {props.shippingBillingPaymentInfo.ccData.ccTypeDesc}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell className="payment-method-info-label">Credit Card Number</Table.Cell>
                    <Table.Cell>
                      {`XXXX-XXXX-XXXX-${props.shippingBillingPaymentInfo.ccData.ccNumber}`}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell className="payment-method-info-label">Exp Date</Table.Cell>
                    <Table.Cell>
                      {props.shippingBillingPaymentInfo.ccData.expiryDate}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell className="payment-method-info-label">CVV</Table.Cell>
                    <Table.Cell>
                      XXX
                    </Table.Cell>
                  </Table.Row>
                </React.Fragment>
              )}
              <DisplayContractPurchaseData
                {...props.shippingBillingPaymentInfo}
              />
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
    </React.Fragment>
  );
}

// ASDS-956
export function mapPaymentDetailsToProps(state) {
  const shippingBillingPaymentInfo =
    state.shippingBillingData.payload.shippingBillingObj.paymentObj;
  return {
    shippingBillingPaymentInfo
  };
}

// Connecting ShippingInfo component to store - ASDS-956
export default connect(mapPaymentDetailsToProps)(ShippingInfoComponent);
